
import { Component, Inject, OnInit, Renderer2, DOCUMENT } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from 'src/app/core/services/language.service';

@Component({
    selector: 'app-language-select',
    templateUrl: './language-select.component.html',
    styleUrls: ['./language-select.component.scss'],
    standalone: false
})
export class LanguageSelectComponent implements OnInit {

  element: any;
  flagvalue: any;
  valueSet: any;
  countryName: any;
  cookieValue: any;

  constructor(@Inject(DOCUMENT) private document: Document, public _languageService: LanguageService, public _cookiesService: CookieService) { }

  ngOnInit(): void {


    this.element = document.documentElement;

    // check if there is lang in cookie
    if (!this._cookiesService.check('lang') || !localStorage.getItem('language')) {
      //set default language to en
      this.setLanguage('en')
    } else {
      this.cookieValue = this._cookiesService.get('lang');
    }

    // Cookies wise Language set
    // this.cookieValue = localStorage.getItem('language');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueSet = 'assets/images/flags/us.svg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
  }

  /***
 * Language Listing
 */
  listLang = [
    { text: 'English', dir: 'ltr', flag: 'assets/images/flags/us.svg', lang: 'en' },
    { text: 'عربي', dir: 'rtl', flag: 'assets/images/flags/sa.svg', lang: 'ar' }
  ];

  /***
   * Language Value Set
   * @param item
   */
  setLanguage(item: any) {
    let currentLang = (item) == 'en' ? this.listLang[0] : this.listLang[1];
    this.countryName = currentLang.text;
    this.flagvalue = currentLang.flag;
    this.cookieValue = currentLang.lang;
    localStorage.setItem('language', currentLang.lang);
    this._languageService.setLanguage(currentLang.lang);
    this.setPageDirection(currentLang.lang);

  }

  setPageDirection(val: any) {
    this.document.documentElement.dir = ((val == 'en') ? 'ltr' : 'rtl');
    this.document.documentElement.lang = ((val == 'en') ? 'en' : 'ar');
  }

}
